module.exports = __webpack_public_path__ + "img/footer-creadores.0948d5cf.png";